import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";

const s3Client = new S3Client({
  region: process.env.REACT_APP_AWS_S3_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
  forcePathStyle: false,
  useDualstackEndpoint: false,
  useArnRegion: true,
  retryMode: "standard",

  // MOST IMPORTANT → completely disable the checksum algorithm wrapper
  defaultsMode: "standard",
  tls: true,
  // This removes the middleware that calls getReader()
  checksumAlgorithms: [],
});

export const uploadFile = async (fileName, file) => {
  try {
    const folder = process.env.REACT_APP_AWS_SUB_FOLDER
      ? `${process.env.REACT_APP_AWS_SUB_FOLDER}/`
      : "";

    // ✅ Convert File to a browser ReadableStream
    // const readableStream = file.stream();

    const params = {
      Bucket: process.env.REACT_APP_AWS_BUCKET,
      Key: fileName,
      Body: file,          // <-- STREAM UPLOAD
      ContentType: file.type,
      ACL: "public-read",
    };

    const res = await s3Client.send(new PutObjectCommand(params));

    if (res.$metadata.httpStatusCode !== 200) {
      throw new Error(`Upload failed: ${res.$metadata.httpStatusCode}`);
    }

    return {
      success: true,
      url: `https://${process.env.REACT_APP_AWS_BUCKET}.s3.${process.env.REACT_APP_AWS_S3_REGION}.amazonaws.com/${folder}${fileName}`,
    };
  } catch (err) {
    console.error("S3 Upload Error:", err);
    return { success: false, error: err.message };
  }
};

export const handleFileChange = async (file, setUploadedFileUrl) => {
  try {
    if (!file) throw new Error("No file provided");

    const fileName = file.name;

    const uploadRes = await uploadFile(fileName, file);

    if (!uploadRes.success) throw new Error(uploadRes.error);

    if (typeof setUploadedFileUrl === "function") {
      setUploadedFileUrl(uploadRes.url);
    }

    return "File uploaded successfully";
  } catch (err) {
    console.error("Error in handleFileChange:", err);
    return err.message;
  }
};
